var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"charpter2"},[_c('CharpterTwo')],1)}
var staticRenderFns = []

export { render, staticRenderFns }